import { render } from "./v-modal.vue?vue&type=template&id=040f3161&scoped=true&ts=true"
import script from "./v-modal.vue?vue&type=script&lang=ts"
export * from "./v-modal.vue?vue&type=script&lang=ts"

import "./v-modal.vue?vue&type=style&index=0&id=040f3161&scoped=true&lang=css"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040f3161"]])

export default __exports__